import { type ReactNode, useEffect } from 'react';
import { officeReady } from '@/services/office/officeReady';
import { onSelectionChanged, getEffectiveSelection } from '@/services/office/selection';
import { useSelectionStore } from '@/stores/selectionStore';

export function OfficeProvider({ children }: { children: ReactNode }) {
  const setItems = useSelectionStore((s) => s.setItems);

  // Non-blocking: always render children. Office readiness only gates the
  // selection-change wiring, not the whole UI. Gating the render on
  // Office.onReady previously left the task pane fully blank when onReady was
  // slow or never fired (pinned pane after a refresh).
  useEffect(() => {
    let cleanup: (() => void) | undefined;
    void officeReady()
      .then(() => {
        cleanup = onSelectionChanged(setItems);
        // Seed the store with the current selection: onSelectionChanged only
        // installs listeners for *future* changes, so without this the store
        // stays empty (and the "Ranger ici" button hidden) whenever the pane
        // opens on an already-selected/open mail — e.g. a pinned pane.
        void getEffectiveSelection().then(setItems).catch(() => {});
      })
      .catch(() => {
        // ignore — selection wiring is best-effort
      });
    return () => cleanup?.();
  }, [setItems]);

  return <>{children}</>;
}
